

import style from "./style.module.css";


export const Thankyou = () => (
  <section className={`${style.thank_section}`}>
    <div className="container1 p-5">
      <div className="row text-center mb-5">
        <div className={`col-md-6 max-sm:ml-[3rem] md:ml-[-2rem] xl:ml-[-9rem] ${style.logo}   `}>
          <a href="/">
            <img
              className="logo1"
              src={"/NC-Logo.png"}
              alt="logo"
              width={"180"}
              height={"180"}

              />
          </a>
        </div>
        <div className="col-md-6 max-sm:mt-[3rem] mt-[5rem] mb-6 ">
             <div className="col-md-12 mt-4 pd-t2 mb-6">
          <span className={`${style.top}`}>All Set..!</span>
        </div>
        <div className="col-md-12 mb-4">
          <span className={`${style.middle}`}>
            Thank You For Sharing Your Information
          </span>
        </div>
        <div className="col-md-12 mb-4">
          <span className={`${style.bottom}`}>
            Our Team will call you shortly to share all the details about
            Royale Estate Group.{" "}
          </span>
        </div>

        <div className="col-md-12">
          <a href="/"
            target="" rel="noreferrer">
            <button className={`${style.submit_btn} mb-2 mt-4 `}>
              <strong>Back to Home Screen</strong>
            </button>{" "}

          </a>
        </div>
        </div>
     
      </div>
    </div>
  </section>
  );

